import React, { useCallback, useContext } from 'react';
import { Field, Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import { Button } from 'ncoded-component-library';
import api from 'api';
import CurrentUserContext from 'providers/CurrentUser';
import InputField from 'components/InputField/InputField.component';
import AuthContext from 'providers/Auth/Auth.context';
import './AuthVerification.styles.scss';

type AuthPhoneNumberProps = Record<string, any>;

const AuthPhoneNumber: React.FC<AuthPhoneNumberProps> = (props) => {
  const { t } = useTranslation();
  const { popError, popSuccess } = useContext(PopNotificationsContext);
  const { user, updateUser } = useContext(CurrentUserContext);
  const { logoutRequest } = useContext(AuthContext);

  const handleSubmit = useCallback(
    async ({ verificationCode }: { verificationCode: string }) => {
      try {
        const { data } = await api.authProcess.verificateCode(verificationCode);
        updateUser(data);
        popSuccess(t('verify-phone-success'));
        logoutRequest();
      } catch (error: any) {
        popError(t('verify-phone-error'));
        console.error(error);
      }
    },
    [logoutRequest, popError, popSuccess, t, updateUser],
  );

  const handleSendAgain = useCallback(async () => {
    try {
      await api.authProcess.initiateVerification();
      popSuccess(t('verification-send-success'));
    } catch (error: any) {
      popError(t('verification-send-error'));
      console.error(error);
    }
  }, [popError, popSuccess, t]);

  return (
    <div className="auth-form-wrapper">
      <h2>{t('verify-phone-title')}</h2>
      <p>{t('verify-phone-paragraph')}</p>
      <Form
        onSubmit={handleSubmit}
        render={({ handleSubmit, submitting, valid }) => {
          const {
            phoneNumber: { refferenceNumber, number },
          } = user;
          return (
            <form
              onSubmit={handleSubmit}
              className="auth-verification"
              autoComplete="off"
            >
              <div className="auth-verification__paragraph">
                <span>{`${refferenceNumber} ${number}`}</span>
                <p>
                  {t('wrong-number')}
                  <Button
                    variant="link"
                    onClick={() => updateUser({ ...user, phoneNumber: null })}
                  >
                    {t('change-it')}
                  </Button>
                </p>
              </div>
              <Field
                name="verificationCode"
                component={InputField}
                placeholder={t('code-placeholder')}
                required
                maxLength={4}
              />
              <p>
                {t('code-not-received')}
                <Button variant="link" onClick={handleSendAgain}>
                  {t('send-again')}
                </Button>
              </p>
              <Button type="submit" disabled={submitting || !valid}>
                {t('verify')}
              </Button>
            </form>
          );
        }}
      />
    </div>
  );
};

export default AuthPhoneNumber;
